export default __webpack_public_path__ + "static/media/down-arrow.955ac481.svg";